import { cloudUri, firebase } from '../../firebase'

export default {
  state: {
    documents: []
  },
  mutations: {
    setDocuments(state, documents) {
      state.documents = documents
    }
  },
  getters: {
    allDocuments(state) {
      return state.documents
    }
  },
  actions: {
    getDocuments(context, id) {
      const tmpDocs = []
      firebase.firestore()
        .collection('documents')
        .where('id', '==', id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              id: doc.id,
              ...doc.data()
            }
            tmpDocs.push(data)
          })
          context.commit('setDocuments', tmpDocs)
        })
    },
    downloadCloudFile(stateObj, path) {
      const gsReference = this.$storage.refFromURL(cloudUri)

      gsReference.child(path)
        .getDownloadURL()
        .then((url) => {
          window.open(url, '_blank')
        }).catch((error) => {
          switch (error.code) {
            case 'storage/object-not-found':
              console.log('Storage not found')
              break;
            case 'storage/unauthorized':
              console.log('Unauthorized')
              break;
            case 'storage/canceled':
              console.log('Cancelled')
              break;
            case 'storage/unknown':
              console.log('Unknown')
              break;
            default:
              // o.O
              break;
          }
        })
    }
  }
}
